// extracted by mini-css-extract-plugin
export default {"container":"PathView_container__bRzvF"};